import { MailToHyperlink } from '@strata/react-hyperlink';

import { Overview } from 'components/shared/Overview';
import { Section } from 'components/shared/Section';

const templatesOverview = [
    <div key="1">
        <p>
            Free Market Health Templates are easy-to-use pre-made designs for creating consistent
            and brand-compliant communications. Uses include:
        </p>
        <ul>
            <li>Sales Presentations</li>
            <li>Quarterly Business Report Presentations</li>
            <li>User Guides</li>
        </ul>
        <h4 className="margin__top--large">
            For questions related to marketing or templates and files please reach out to:
        </h4>
        <MailToHyperlink
            linkText="Marketing Team"
            subject="Templates & Files Question"
            emailAddress="marketingcommunications@freemarkethealth.com"
        />
    </div>,
];

export const TemplatesOverview = () => (
    <Overview
        title="Templates & Files Overview"
        description="An extension of the brand guidelines that includes a repository of brand approved templates and files for easily producing consistent communications."
        image="https://sseasacdn.blob.core.windows.net/strata-website/templates-overview.svg"
        content={
            <Section
                title="What are Free Market Health Templates?"
                contentArray={templatesOverview}
            />
        }
    />
);
